<template>
  <SectionElement />
</template>

<script setup lang="ts">
  import type { Component } from 'vue'
  import { computed, h } from 'vue'

  import cardFullWidth from './card/full-width.vue'
  import accordionBlock from './section/accordion-block.vue'
  import anchor from './section/anchor.vue'
  import blogListing from './section/blog-listing.vue'
  import bulletPoints from './section/bullet-points.vue'
  import card from './section/card.vue'
  import cardList from './section/card-list.vue'
  import download from './section/download.vue'
  import emailForm from './section/email-form/form.vue'
  import glassdoor from './section/glassdoor.vue'
  import gradientCallOut from './section/gradient-call-out.vue'
  import gradientSlider from './section/gradient-slider.vue'
  import gridCardGradient from './section/grid-card-gradient.vue'
  import gridCardImage from './section/grid-card-image.vue'
  import heading from './section/heading.vue'
  import hero from './section/hero.vue'
  import iconList from './section/icon-list.vue'
  import jobList from './section/job-list.vue'
  import jobNewsletter from './section/job-newsletter.vue'
  import karaoke from './section/karaoke.vue'
  import leaderListing from './section/leader-listing.vue'
  import linkList from './section/link-list.vue'
  import locationMap from './section/location-map.vue'
  import locationSlider from './section/location-slider.vue'
  import newsletter from './section/newsletter.vue'
  import numbers from './section/numbers.vue'
  import parallaxCards from './section/parallax-cards.vue'
  import prospectList from './section/prospect-list.vue'
  import scrollingCards from './section/scrolling-cards.vue'
  import scrollingStory from './section/scrolling-story.vue'
  import sliderBottomHeading from './section/slider-bottom-heading.vue'
  import sliderTopHeading from './section/slider-top-heading.vue'
  import socialLinks from './section/social-links.vue'
  import stickyMenu from './section/sticky-menu.vue'
  import storiesContainer from './section/stories-container.vue'
  import tabs from './section/tabs.vue'
  import textBlock from './section/text-block.vue'
  import ttfPromo from './section/ttf-promo.vue'
  import typoCallOut from './section/typo-call-out.vue'
  import video from './section/video.vue'
  import YoutubeSlider from './section/youtube-slider.vue'
  import YoutubeVideo from './section/youtube-video.vue'

  type PageBuilderElement = {
    component_type: string
    [key: string]: unknown
  }

  const props = defineProps<{ element: PageBuilderElement }>()

  const sections: Record<string, Component> = {
    hero,
    karaoke,
    ttf_promo: ttfPromo,
    gradient_call_out: gradientCallOut,
    parallax_scrolling_cards: parallaxCards,
    slider_bottom_heading: sliderBottomHeading,
    typo_call_out: typoCallOut,
    slider_top_heading: sliderTopHeading,
    grid_card_gradient: gridCardGradient,
    social_links: socialLinks,
    newsletter,
    download,
    video,
    grid_card_image: gridCardImage,
    heading,
    stories_container: storiesContainer,
    card,
    gradient_slider: gradientSlider,
    glassdoor,
    scrolling_cards: scrollingCards,
    scrolling_story: scrollingStory,
    blog_listing: blogListing,
    text_block: textBlock,
    full_width_card: cardFullWidth,
    bullet_points: bulletPoints,
    link_list: linkList,
    icon_list: iconList,
    tabs,
    card_list: cardList,
    job_list: jobList,
    prospect_list: prospectList,
    job_newsletter: jobNewsletter,
    accordion_block: accordionBlock,
    counter: numbers,
    location_map: locationMap,
    location_slider: locationSlider,
    anchor,
    sticky_menu: stickyMenu,
    email_form: emailForm,
    leader_listing: leaderListing
  }

  const youtubeSections: Record<string, Component> = {
    youtube_slider: YoutubeSlider,
    youtube_video: YoutubeVideo
  }

  const SectionElement = computed(() => {
    const el = props.element
    if (youtubeSections[el.component_type]) {
      return h(youtubeSections[el.component_type], { element: el })
    }
    if (sections[el.component_type]) {
      return h(sections[el.component_type], el)
    }
    return undefined
  })
</script>
